import { ca } from '@cian/analytics';
import { EEstimationTargets } from '@cian/valuation-main-filters-widget';

import { mapEstimationTargetToAnalyticsCategory } from '../constants/filters';
import { IPage } from '../types/redux/page';
import { getSiteType } from '../utils/getSiteType';

function getCategory(url: string): string {
  if (url.includes('category=landSale')) {
    return 'EstateLandCalculator';
  }

  if (url.includes('category=houseSale')) {
    return 'EstateHouseCalculator';
  }

  return 'EstateCalculator';
}

/** https://conf.cian.tech/pages/viewpage.action?pageId=1178206667 */

/** Калькулятор недвижимости */

/** 2. Клик по "Оценить" */
export interface ITrackCalculateClickData {
  page: IPage;
  queryString: string;
  estimationTarget: EEstimationTargets;
  houseId?: number;
  address?: string;
  area?: number;
  roomsCount?: number;
  pushEnabled?: boolean;
  pushNotificationsAllowed?: boolean;
  houseArea?: number;
  landArea?: number;
}

export function trackCalculateClick(params: ITrackCalculateClickData) {
  const {
    page,
    queryString,
    address,
    area,
    roomsCount,
    pushNotificationsAllowed,
    pushEnabled,
    houseArea,
    landArea,
    estimationTarget,
    houseId,
  } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: mapEstimationTargetToAnalyticsCategory[estimationTarget],
    action: 'Click',
    label: 'Calculate',
    page: {
      pageType: page.pageType,
      siteType: getSiteType(page.deviceType),
      queryString,
      extra: {
        address: address || undefined,
        area: area || undefined,
        roomsCount: roomsCount || undefined,
        togglePushStatus: pushEnabled ? 1 : 0,
        settingsPushEnabled: pushNotificationsAllowed ? 1 : 0,
        houseArea: houseArea || undefined,
        landArea: landArea || undefined,
        clarificationNeeded: [EEstimationTargets.house, EEstimationTargets.land].includes(estimationTarget)
          ? houseId
            ? 0
            : 1
          : undefined,
      },
    },
  });
}

/** Редизайн главной страницы оценки */
/** 1. Клик на кнопку "Перейти к оценке", "Оценить другую квартиру" - скролл к форме или открытие модальной формы */
export function trackGoToEstimBtnClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'GoToValuation',
  });
}

/** 2. Клики на картинки в блоке "Что будет в отчете" */
export function trackAboutReportImageClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: 'GoToValuationFromReport',
  });
}

/** 3. Клик на кнопки "Посмотреть отчет" в блоке истории оценок */
export function trackRedirectToValReport(url: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: getCategory(url),
    action: 'Click',
    label: 'GoToValuationReport',
  });
}

/** 4. Клик на крестик удаления оценки из истории оценки */
export function trackEstimHistoryItemDelete(url: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: getCategory(url),
    action: 'Click_sopr',
    label: 'DeleteEstimationHistory',
  });
}

/** 9. Клик на ссылку "Подробнее об оценке". Обязательно в GA */
export function trackValInfoClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'ValuationInfo',
  });
}

/** TEASER */
/** 1. Просмотр блока "Что будет в отчете" */
export function trackAboutReportShow() {
  ca('teaser', {
    product: {
      name: 'what_report',
    },
  });
}

/** 2. Просмотр блока "Для чего" продавцу */
export function trackOurBuyersShow() {
  ca('teaser', {
    product: {
      name: 'for_what_buyer',
    },
  });
}

/** 3. Просмотр блока "Для чего" покупателю */
export function trackOurSellersShow() {
  ca('teaser', {
    product: {
      name: 'for_what_seller',
    },
  });
}

/** 4. Просмотр блока "Ключевые цифры" */
export function trackOurNumbersShow() {
  ca('teaser', {
    product: {
      name: 'key_numbers',
    },
  });
}

/** 5. Просмотр блока "Как это работает" */
export function trackHowItWorksShow() {
  ca('teaser', {
    product: {
      name: 'how_to_work',
    },
  });
}

/** 6. Просмотр блока "Уже оценивали" */
export function trackEstimHistoryShow() {
  ca('teaser', {
    product: {
      name: 'estimation_history',
    },
  });
}

/** https://conf.cian.tech/pages/viewpage.action?pageId=1339097555 */

/** 1. Клик в модалке включения уведомлений */
export function trackPushSettingsPopupClick(turnOn: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: turnOn ? 'goToSettings' : 'no',
  });
}

/** 2. Возврат пользователя из системных настроек управления уведомлениями */
export function trackReturnedFromPushSystemSettings(pushAllowed: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'SettingsPush_sopr',
    label: pushAllowed ? 'enabled' : 'disabled',
  });
}
